

import React, { Component } from 'react';

import Home from './Home';
import About from "./About";



import {
  HashRouter as Router,
  Routes,
  Route

} from "react-router-dom";
import Research from './research';
import Publication from './publication';
import Project from './project';
import Academics from './Academics';
import Experience from './Experience';
import News from './news';





export default class App extends Component {
  
  

  render() {


    return (
      <Router>


        <Routes>

          <Route exact path="/" element={<Home />} />
          <Route path="/about-me" element={<About />} />
          <Route path="/academic" element={<Academics />} />
      
          <Route path="/research/*" element={<Research />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/news" element={<News />} />
       
       
        </Routes>



      </Router>


    )

  }
}
